// Department Links — rewrites storefront breadcrumb + product-meta category links
// to point at the parts finder with the matching department. Only runs when a
// product SKU is present (i.e. on a product-detail page).
//
// GW-714: the PDP breadcrumb (rendered by the storefront view, not our code)
// emits the category crumb as `<a href="javascript:;">Engine Drive</a>`, so it
// looked like a link but did nothing, and the old `/products/browse` selector
// never matched it. Every crumb except Home and the current product (li.active)
// now gets a real href: the first category level → its parts-finder department,
// deeper levels → that department narrowed to the sub-category.
//
// Config (optional, on any [data-parts-department-links] element or the page):
//   data-sku-selector="#product-sku"

import { getTopDocument, getSku } from '../shared/dom.js';

// Same storefront-relative browse URL the departments slider links to, so the
// shopper stays on the storefront domain (/parts-finder is served there).
var PARTS_FINDER_BROWSE = '/parts-finder?page=1&pageSize=24&sort=relevance';

// Match the API slug: lowercase, spaces→underscores, keep a-z0-9_-
function slugDepartmentName(name) {
  if (!name || typeof name !== 'string') return '';
  return name.trim().toLowerCase()
    .replace(/\s+/g, '_')
    .replace(/[^a-z0-9_-]/g, '')
    .replace(/_+/g, '_')
    .replace(/^_|_$/g, '') || '';
}

function departmentHref(name) {
  var slug = slugDepartmentName(name);
  return slug ? PARTS_FINDER_BROWSE + '&department=' + encodeURIComponent(slug) : '';
}

// A crumb anchor that goes nowhere useful: javascript:, "#", empty, or the
// storefront's own category browse (replaced by the parts finder).
function isDeadOrBrowseHref(a) {
  var href = (a.getAttribute('href') || '').trim();
  return !href || href === '#' || /^javascript:/i.test(href) || href.indexOf('/products/browse') !== -1;
}

function applyBreadcrumbLinks(doc) {
  doc.querySelectorAll('.breadcrumb-contain .breadcrumb').forEach(function (ol) {
    var department = '';
    ol.querySelectorAll('li').forEach(function (li, i) {
      if (i === 0 || li.classList.contains('active')) return; // Home / current page
      var a = li.querySelector('a');
      var text = ((a || li).textContent || '').trim();
      if (!text) return;
      if (!department) {
        department = text;
        if (a && isDeadOrBrowseHref(a)) {
          var href = departmentHref(text);
          if (href) a.setAttribute('href', href);
        }
        return;
      }
      if (a && isDeadOrBrowseHref(a)) {
        var base = departmentHref(department);
        if (base) a.setAttribute('href', base + '&category=' + encodeURIComponent(text));
      }
    });
  });
}

function applyLinks() {
  var doc = getTopDocument();
  applyBreadcrumbLinks(doc);
  doc.querySelectorAll('.product-meta a[href*="/products/browse"]').forEach(function (a) {
    var href = departmentHref((a.textContent || '').trim());
    if (href) a.setAttribute('href', href);
  });
}

export function init() {
  var selEl = getTopDocument().querySelector('[data-parts-department-links]');
  var selector = (selEl && selEl.getAttribute('data-sku-selector')) || '#product-sku';
  if (!getSku(selector)) return; // not a product page
  applyLinks();
}

export var id = 'department-links';
